/**
 *
 * Asynchronously loads the component for ApplicantDrawerPopup
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
